import { useEffect, useRef } from 'react';
import { getDimensions } from './helpers';
export const useDimensions = () => {
    const dimensions = useRef(getDimensions());
    useEffect(() => {
        const handleResize = () => {
            dimensions.current = getDimensions();
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [dimensions.current]);
    return dimensions.current;
};
//# sourceMappingURL=useDimensions.js.map